const sizes = {
  value: '12px',
  caption: '10px',
}

export { sizes }
